<div class="platforms-tab">
  @if (!hasPlatforms) {
    <div class="empty-state">
      <div class="empty-state-content">
        <h3 class="empty-state-title">No platforms configured</h3>
        <p class="empty-state-description">Connect an integration to enable policies for your connected platforms.</p>
        <app-button buttonText="Connect integration" (buttonClicked)="onConnectIntegration()"></app-button>
      </div>
    </div>
  }

  @if (hasPlatforms) {
    <div class="platforms-layout">
      <div class="platforms-sidebar">
        <div class="sidebar-header">
          <span class="sidebar-title">Platforms</span>
          <span class="add-link" (click)="onAddPlatform()">+ Add</span>
        </div>
        <div class="platforms-list">
          @for (platform of platforms; track platform.id) {
            <div
              class="platform-item"
              [class.platform-item-selected]="isPlatformSelected(platform.id)"
              (click)="onPlatformSelect(platform.id)"
            >
              <img [src]="platform.iconPath" [alt]="platform.name" class="platform-icon" />
              <span class="platform-name">{{ platform.name }}</span>
            </div>
          }
        </div>
      </div>

      <div class="platform-detail">
        @if (selectedPlatformId) {
          <p class="placeholder-text">Platform configuration panel will be implemented in Phase 3</p>
        } @else {
          <p class="placeholder-text">Select a platform to view its configuration</p>
        }
      </div>
    </div>
  }
</div>
